import { type RoleAttributes } from '../types'

// TODO need to remove user roles arg. Only do fetch once.

/** Check if required roles are contained in a list of roles.
 * Use partialRoleList = true if there are multiple roles, but only **any** one role is required.
 * The default requires **every** role in the required list */
export const checkRoles = (
    userRoles: RoleAttributes[],
    requiredRoleNames: string[],
    partialRoleList = false,
): boolean =>
    partialRoleList
        ? requiredRoleNames.some((reqRole) => userRoles.map((r) => r.name).includes(reqRole))
        : requiredRoleNames.every((reqRole) => userRoles.map((r) => r.name).includes(reqRole))
